<p>generic-object-editor works!</p>
